<template>
  <div>
<Loader :isLoading='Loading'/>
  <header>
        <Header
        :BackPage='true'
        :HideCart='true'
        Title='Meus Pedidos'
        class="mb-5" 
        />
  </header>

  <section>



    <MainContainer
    class='ajust'
    >


          <TitleH3
          class=''
          Text='Acompanhe seus pedidos em tempo real'
          />
      
        <OrderTable
        :ArrayPedidos='pedidos_finalizados'
        />
    <div class='Spacer'></div>
    </MainContainer>



<FooterContainer>

        
        <Button
        id='first_button'
        Type='button'
        Text='VOLTAR'
        :ButtonFunction='back_to_home'

        />
        <ButtonOutline
        id=''
        Type='button'
        Text='ATUALIZAR'
        :ButtonFunction='atualizar'
        Icon='fas fa-sync-alt'
        />



</FooterContainer>



  </section>
  </div> 
</template>

<script>

import Header from '../../components/Header/Header'
import TitleH3 from '../../components/Title/TitleH3'
import Button from '../../components/Button/ButtonCallToAction'
import ButtonOutline from '../../components/Button/ButtonCallToActionOutline'
import FooterContainer from '../../components/Container/FooterContainer'
import MainContainer from '../../components/Container/MainContainer'
import OrderTable from '../../components/Table/OrderTable'
import {mapActions, mapState} from 'vuex'
import Loader from '../../components/Load/LoadOverlay'

export default {
  components: {

    Header,
    TitleH3,
    FooterContainer,
    Button,
    ButtonOutline,
    OrderTable,
    MainContainer,
    Loader,
  },
  data() {
    return {
      pedidos_finalizados:[],
      user:'',
      Loading:false
    }
  },
  methods: {
    ...mapActions('acompanhar_pedido',['ActionGetFinishOrder']),
    back_to_home() {
      this.$router.push({name:'home'})
    },
    async atualizar() {
      this.Loading = !this.Loading
      await this.ActionGetFinishOrder(this.user)
      this.pedidos_finalizados = this.finishOrders
      this.Loading = !this.Loading
    }
  },
  async created () {
    this.user = localStorage.getItem('id_user');
    if(this.user) {
      this.Loading = !this.Loading
      await this.ActionGetFinishOrder(this.user)
      this.pedidos_finalizados = this.finishOrders
      this.Loading = !this.Loading
    }
  },
  computed: {
    ...mapState('acompanhar_pedido',['finishOrders'])
  },
      mounted() {
  }
}
</script>

<style scoped lang="css">


.Spacer{
  height: 12.625rem;
}


.inputName{
  margin-top:5.25rem;
}

#first_button{
  margin-bottom:.5rem;
}
  .ajust{
    display:block;
    width:95%;    
    margin-left:auto;
    margin-right:auto;  
    margin-top:2.25rem;  
}

  @media (min-width: 800px) {
  .ajust{
    display:block;
    width:100%;    
    margin-left:auto;
    margin-right:auto;  
    
}
  }
</style>
